import { FiltersIcon } from '@/components/icons/filters';

import cn from './styles.module.sass';

interface IOpenFiltersBtnProps {
    totalActiveFilters: number;
    onClick?: VoidFunction;
}

export const OpenFiltersBtn = ({ totalActiveFilters, onClick }: IOpenFiltersBtnProps) => {
    return (
        <div onClick={onClick} className={cn.openFiltersBtn}>
            <div className={cn.totalActiveFiltersContainer}>
                {totalActiveFilters > 0 && (
                    <span className={cn.totalActiveFilters}>
                        {totalActiveFilters > 0 && totalActiveFilters}
                    </span>
                )}
            </div>

            <span className={cn.btnName}>Фильтры</span>
            <span className={cn.filtersIcon}>{FiltersIcon}</span>
        </div>
    );
};
